import {defineStore} from "pinia";
import api from "../../api";
import utils from "../../services/utils";
import {ENUMS} from "../../services/enums";

export const useCampaignStore = defineStore('campaignsModule', {
  state: () => {
    return {
      filters: {
        campaigns: {
          channel: 0,
          status: 1
        },
        costs: {
          sortBy: null
        },
        unitCounts: {
          sortBy: null
        },
      },
      filterOptions: {
        campaignStatuses: [
          {value: 1, label: "Active"},
          {value: 2, label: "Archived"},
          {value: 0, label: "Both"}
        ],
        costSorting: [
          {value: null, label: "Unsorted"},
          {value: 1, label: "Lowest Cost"},
          {value: 2, label: "Highest Cost"},
          {value: 3, label: "Latest Date"},
          {value: 4, label: "Oldest Date"},
        ],
        unitCountSorting: [
          {value: null, label: "Unsorted"},
          {value: 1, label: "Lowest Count"},
          {value: 2, label: "Highest Count"},
          {value: 3, label: "Latest Date"},
          {value: 4, label: "Oldest Date"},
        ],
      },
      campaigns: [],
      activeCampaign: {
        costs: [],
        deleted_at: null,
      },
      activeUnitCounts: []
    };
  },
  getters: {
    filteredCampaigns(state) {
      let campaigns = state.campaigns.filter(campaign => {
        if (state.filters.campaigns.channel) {
          return campaign.channel === state.filters.campaigns.channel;
        }

        return true;
      });

      campaigns = campaigns.filter(campaign => {
        if (!state.filters.campaigns.status) {
          return true;
        }

        if (state.filters.campaigns.status === 1) {
          return campaign.deleted_at === null;
        }

        return campaign.deleted_at !== null;
      });

      return campaigns.sort((a, b) => (a.label > b.label) ? 1 : -1)
    },
    filteredMessage(state) {
      const campaignLabel = utils.newGetEnumLabel(state.filters.campaigns.channel, ENUMS.CampaignChannelEnum, "");

      let statusText = '';
      switch (state.filters.campaigns.status) {
        case 1:
          statusText = 'with active status';
          break;
        case 2:
          statusText = 'with archive status';
          break;
      }

      return `You don't have any ${campaignLabel.toLowerCase()} campaigns ${statusText}`;
    },
    sortedCosts(state) {
      const costs = state.activeCampaign.costs;

      switch (state.filters.costs.sortBy) {
        case 1:
          return costs.sort((a, b) => a.amount - b.amount);
        case 2:
          return costs.sort((a, b) => b.amount - a.amount);
        case 3:
          return costs.sort((a, b) => new Date(a.date) - new Date(b.date));
        case 4:
          return costs.sort((a, b) => new Date(b.date) - new Date(a.date));
        default:
          return costs;
      }
    },
    sortedUnitCounts(state) {
      const unitCounts = state.activeUnitCounts;

      switch (state.filters.unitCounts.sortBy) {
        case 1:
          return unitCounts.sort((a, b) => a.count - b.count);
        case 2:
          return unitCounts.sort((a, b) => b.count - a.count);
        case 3:
          return unitCounts.sort((a, b) => new Date(a.date) - new Date(b.date));
        case 4:
          return unitCounts.sort((a, b) => new Date(b.date) - new Date(a.date));
        default:
          return unitCounts;
      }
    },
  },
  actions: {
    loadAllCampaigns() {
      return api.campaigns.all().then(response => {
        this.campaigns = response.data;
      });
    },
    loadUnitCounts() {
      return api.campaigns.getUnitCounts(this.activeCampaign.id).then(response => {
        this.activeUnitCounts = response.data;
      });
    },
    setActiveCampaign(campaign) {
      this.activeCampaign = campaign;
    },
    setCampaignsChannelFilter(channelFilter) {
      this.filters.campaigns.channel = channelFilter;
    },
    setCampaignsStatusFilter(statusFilter) {
      this.filters.campaigns.status = statusFilter;
    },
    setCostsSortBy(sortBy) {
      this.filters.costs.sortBy = sortBy;
    },
    setUnitCountsSortBy(sortBy) {
      this.filters.unitCounts.sortBy = sortBy;
    },
    resetCampaignsFilters() {
      this.filters.campaigns = {
        channel: 0,
        status: 1
      };
    },
    resetActiveCampaign() {
      this.filters.costs.sortBy = null;
      this.filters.unitCounts.sortBy = null;
      this.activeCampaign = {
        costs: [],
        deleted_at: null,
      };
    },
    resetStore() {
      this.$reset();
    }
  }
});
